export default "{\n    \"hiddenOptionsWarningText\": \"N'affiche pas toutes les options, recherchez pour filtrer.\"\n}\n"